import { COMPANY_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
        path: "/super-admin/company",
        name: "company-management",
        component: () => import("@/views/super-admin/company/CompanyView.vue"),
        meta: {
          gate: COMPANY_ACCESS,
          requiresSuperAdmin: true,
          pageTitle: "Company Management",
          layout: "super-admin",
        },
    },
    {
        path: "/super-admin/company/:payment_method/:id",
        name: "company-subscription-details",
        component: () => import("@/views/super-admin/company/CompanySubscriptionHistoryView.vue"),
        meta: {
          gate: COMPANY_ACCESS,
          requiresSuperAdmin: true,
          pageTitle: "Company Subscription History",
          layout: "super-admin",
        },
    },
  ];
  